import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getItemWithExpiry,
  hasRoles,
  removeItemWithExpiry,
  setItemWithExpiry,
} from "../../lib/utility";
import { hasUserProfileImage } from "../../lib/profileImage";
import axios from "../../redux/axios";

const initialState = {
  getProfile: globalThis.profileData ?? {},
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  profileUpdate: {},

  isFetchingProfileUpdate: false,
  isSuccessProfileUpdate: false,
  isErrorProfileUpdate: false,
  isErrorMessageProfileUpdate: "",

  getalert: {},
  isFetchingAlert: false,
  isSuccessAlert: false,
  isErrorAlert: false,
  errorMessageAlert: "",

  isFetchingApiKey: false,
  isSuccessApiKey: false,
  isErrorApiKey: false,
  errorMessageApiKey: "",
};

export const getProfileData = createAsyncThunk(
  "login/user/data",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let user = auth.user;
      const isSellerManager = hasRoles("seller,manager", user);

      const profileData = getItemWithExpiry("profileData");

      if (profileData) {
        return { ...profileData, status: 200 };
      }

      let tokenStr = auth.user.accessToken;
      let { data, status } = await axios.get(
        isSellerManager
          ? `/sales/view-sales-entry/` + auth.user.id
          : `/login/user/data`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        const pData = isSellerManager
          ? {
              ...data["seller"],
              profileName: data.profileName,
              profilePath: data.profilePath,
              status,
            }
          : { ...data, status };

        setItemWithExpiry("profileData", pData, 10800);
        return pData;
      } else {
        return thunkAPI.rejectWithValue({ ...data, status });
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const userProfileUpdate = createAsyncThunk(
  "login/updateProfile",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { editableFields, selectedFile } = udata;
      const formData = new FormData();

      for (const key in editableFields) {
        if (
          Object.prototype.hasOwnProperty.call(editableFields, key) &&
          editableFields[key] !== undefined &&
          editableFields[key] !== null &&
          (editableFields[key] !== "" || editableFields[key] !== 0)
        ) {
          formData.append(key, editableFields[key]);
        }
      }

      if (selectedFile) {
        formData.append("image", selectedFile);
      }

      if (hasRoles("seller,manager", auth.user)) {
        formData.append("id", auth.user.id);
      }

      const { data, status } = await axios.put(
        hasRoles("seller,manager", auth.user)
          ? `/sales/update`
          : `/login/updateProfile`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (status.toString().startsWith("2")) {
        return { ...data, status };
      } else {
        return thunkAPI.rejectWithValue({ ...data, status });
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const regenerateApiKey = createAsyncThunk(
  "login/changeApiKey",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth?.user?.accessToken;
      const username =
        udata?.userName ||
        auth?.user?.userName ||
        auth?.user?.username ||
        "";
      const headers = {
        username: username,
      };
      if (tokenStr) {
        headers.Authorization = `Bearer ${tokenStr}`;
      }
      const { data, status } = await axios.get("/login/changeApiKey", {
        headers,
      });
      if (status.toString().startsWith("2")) {
        const msg =
          (typeof data === "string" && data.trim()) ||
          (typeof data?.message === "string" && data.message.trim()) ||
          (typeof data?.msg === "string" && data.msg.trim()) ||
          (typeof data?.data === "string" && data.data.trim()) ||
          "";
        return { message: msg, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) throw err;
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    updateUserData: (state, action) => {
      (state.getProfile.displaySmscId = action.payload.displaySmscId),
        (state.getProfile.replacedSenderId = action.payload.replacedSenderId);
    },
    mergeProfileFields: (state, action) => {
      state.getProfile = { ...state.getProfile, ...action.payload };
      globalThis.profileData = {
        ...(globalThis.profileData ?? {}),
        ...state.getProfile,
      };
    },
    clearStateProfile: (state, { payload }) => {
      state.getProfile = {};
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = "";
      state.isFetchingApiKey = false;
      state.isSuccessApiKey = false;
      state.isErrorApiKey = false;
      state.errorMessageApiKey = "";
    },
    clearStateProfileUpdateData: (state, { payload }) => {
      state.profileUpdate = {};
      state.isFetching = false;
      state.isSuccessProfileUpdate = false;
      state.isErrorProfileUpdate = false;
      state.isErrorMessageProfileUpdate = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfileData.fulfilled, (state, action) => {
        state.getProfile = action.payload;
        globalThis.profileData = action.payload;
        state.isFetching = false;
        state.isSuccess = true;
        state.errorMessage = action.payload;
      })
      .addCase(getProfileData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getProfileData.rejected, (state, action) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = action.payload
          ? action.payload.message
          : "Internal error";
      })

      
      .addCase(userProfileUpdate.fulfilled, (state, action) => {
        const responseData = action.payload?.data ?? action.payload;
        state.profileUpdate = responseData;
        state.isFetchingProfileUpdate = false;
        state.isSuccessProfileUpdate = true;
        state.isErrorMessageProfileUpdate = responseData;
        removeItemWithExpiry("profileData");

        if (hasUserProfileImage(responseData)) {
          state.getProfile = { ...state.getProfile, ...responseData };
          globalThis.profileData = {
            ...(globalThis.profileData ?? {}),
            ...state.getProfile,
          };
          setItemWithExpiry("profileData", state.getProfile, 10800);
        }
      })
      .addCase(userProfileUpdate.pending, (state) => {
        state.isFetchingProfileUpdate = true;
        state.isErrorMessageProfileUpdate = "";
        state.isErrorProfileUpdate = false;
      })
      .addCase(userProfileUpdate.rejected, (state, action) => {
        state.isFetchingProfileUpdate = false;
        state.isErrorProfileUpdate = true;
        state.isErrorMessageProfileUpdate = action.payload
          ? action.payload.message
          : "Internal error";
      })
      .addCase(regenerateApiKey.pending, (state) => {
        state.isFetchingApiKey = true;
        state.isSuccessApiKey = false;
        state.isErrorApiKey = false;
      })
      .addCase(regenerateApiKey.fulfilled, (state) => {
        state.isFetchingApiKey = false;
        state.isSuccessApiKey = true;
      })
      .addCase(regenerateApiKey.rejected, (state, { payload }) => {
        state.isFetchingApiKey = false;
        state.isErrorApiKey = true;
        state.errorMessageApiKey =
          payload?.message || "Failed to regenerate API key";
      });
  },
});

export const {
  clearStateProfile,
  clearStateProfileUpdateData,
  updateUserData,
  mergeProfileFields,
} = profileSlice.actions;

export function clearState() {
  return async (dispatch) => {
    dispatch(clearStateProfile());
  };
}
export function clearStateProfileUpdate() {
  return async (dispatch) => {
    dispatch(clearStateProfileUpdateData());
  };
}

export const profileSelector = (state) => state.profile;

export default profileSlice.reducer;
